import FolderOffOutlined from "@mui/icons-material/FolderOffRounded";
import { Stack, Typography } from "@mui/material";
import React from "react";

type Props = {
  text: string;
};

export function Empty({ text }: Props) {
  return (
    <Stack justifyContent="center" alignItems="center" height="100%">
      <FolderOffOutlined fontSize="large" color="primary" />
      <Typography textAlign="center" fontSize={16} color="grey.400" mt={1}>
        {text}
      </Typography>
    </Stack>
  );
}
